export default [
  {
    title: "仲裁目录",
    link: "ArbList",
    key: "arbitrate:index",
    other: true,
    icon: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/zhongcai.png",
    icon1:
      "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/zhongcai1.png",
    cur: "3-8",
  },
  {
    title: "案件主体",
    link: "subjectActionManage",
    key: "accsuer:index",
    cur: "3-2",
    other: true,
    icon: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/zhuti.png",
    icon1:
      "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/zhuti1.png",
  },
  {
    title: "业务部门",
    link: "team",
    key: "team:index",
    cur: "3-6",
    other: true,
    icon: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/bumen.png",
    icon1:
      "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/bumen1.png",
  },
  {
    title: "代理模式",
    link: "agency",
    key: "agency:index",
    cur: "3-z",
    other: true,
    icon: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/daili.png",
    icon1:
      "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/daili1.png",
  },
  {
    title: "进度期限",
    link: "over",
    key: "over:index",
    cur: "3-5",
    other: true,
    icon: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/chaoqi.png",
    icon1:
      "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/chaoqi1.png",
  },
  {
    title: "业务类型",
    link: "allCar",
    key: "car:index",
    cur: "3-3",
    other: true,
    icon: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/leixing.png",
    icon1:
      "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/leixing1.png",
  },
  {
    title: "案件案由",
    link: "action",
    key: "reason:index",
    cur: "3-4",
    other: true,
    icon: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/anyou.png",
    icon1:
      "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/anyou1.png",
  },
  {
    title: "金融机构",
    link: "bank",
    key: "bank:index",
    other: true,
    icon: "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/jinrong.png",
    icon1:
      "https://xiaoyin-upload-new.oss-cn-hangzhou.aliyuncs.com/file/jinrong1.png",
    cur: "3-7",
  },
];
